import userTrackingSaga from './user-tracking.saga';

export default userTrackingSaga;
